<template>
  <div style="height:100%">
    <div class="main">
      <div class="header">
        <a-button @click="openConfig" type="primary">{{
          $t("page_workstation_maintain_config")
        }}</a-button>
        <div>
          <a-button @click="searchForm">{{
            $t("page_my_document_advanced")
          }}</a-button>
        </div>
      </div>
      <div class="body">
        <ml-table
          :columns="columns"
          :dataSource="data"
          :canChangeColWidth="true"
          :scroll="{ x: 500, y: 500 }"
          rowKey="id"
          :custom-row="rowClick"

        >
          <template slot="maintenance" slot-scope="text, record">
            <a v-if="record.id" @click="openEdit(record)">{{ $t("edit") }}</a>
            <a-popconfirm
              :title="$t('delete_tips')"
              ok-text="Yes"
              cancel-text="No"
              @confirm="delect(record)"
              @cancel="cancel"
            >
              <a v-if="record.id" style="color:red;margin-left:8px">{{ $t("delete") }}</a>
            </a-popconfirm>
          </template>
        </ml-table>
        <a-pagination
        style="float:right;margin-top:20px;margin-right:20px;"
        :total="pagination.total"
        :showTotal="total => `${totalFanyi(total)}`"
        :pageSize="pagination.pageSize"
        :current="pagination.current"
        @change="pageIndexchange"
      ></a-pagination>
      </div>
    </div>
    <a-modal
      :title="modalTitle"
      :visible="ConfigVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <div>
        <a-form-model
          ref="ruleForm"
          :model="configList"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          :rules="rules"
        >
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_configuration_name') + ':'"
                prop="name"
              >
                <a-input
                  v-model="configList.name"
                  :placeholder="$t('common_please_input') + $t('page_console_configuration_name')"
                  :disabled="type === 'edit'"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_notification_type') + ':'"
                prop="type"
              >
                <a-select
                  v-model="configList.type"
                  show-search
                  :filter-option="filterOption"
                  :placeholder="$t('please_select') + $t('page_console_notification_type')"
                  :disabled="type === 'edit'"
                  @change="changeType"
                >
                  <a-select-option
                    v-for="(item, index) in typesList"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-model-item
                :label="$t('page_console_service_provider') + ':'"
                prop="provider"
              >
                <a-select
                  show-search
                  :filter-option="filterOption"
                  v-model="configList.provider"
                  :placeholder="$t('please_select') + $t('page_console_service_provider')"
                  :disabled="type === 'edit'"
                  @change="changeProvider"
                >
                  <a-select-option
                    v-for="(item, index) in providers"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="model">
        <div>
          <div>
            <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol">
              <a-row v-for="(item, index) in modelList" :key="index">
                <a-col :span="24">
                  <a-form-model-item :label="item.name + ':'">
                    <a-input
                      v-model="item.value"
                      :placeholder="$t('common_please_input') + item.name"
                      v-if="item.property === 'properties' ? false : true"
                    />
                    <Other
                      v-if="item.property === 'properties' ? true : false"
                      :placeholder="$t('common_please_input') + item.name"
                      :modelList="modelList"
                      @change="changeValue"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- <a-modal
      :title="$t('page_my_document_advanced')"
      :visible="searchVisible"
      @ok="searchOk"
      @cancel="searchCancel"
    > -->
    <dragModal :title="$t('page_my_document_advanced')" :subTitle="`(${$t('page_console_notification_configuration')})`" width="500px" top="140px" :visible="searchVisible" @close="searchCancel">
      <a-form-model
        ref="ruleForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item :label="$t('page_console_configuration_name') + ':'">
          <a-input
            v-model="searchList.name"
            :placeholder="$t('common_please_input') + $t('page_material_warehousing_p_input')"
          /> </a-form-model-item
        ><a-form-model-item :label="$t('page_console_notification_type') + ':'">
          <a-select
            show-search
            :filter-option="filterOption"
            v-model="searchList.type"
            :placeholder="$t('please_select') + $t('page_material_warehousing_p_select')"
            @change="changeType"
          >
            <a-select-option
              v-for="(item, index) in typesList"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select></a-form-model-item
        ><a-form-model-item :label="$t('page_console_service_provider') + ':'">
          <a-select
            show-search
            :filter-option="filterOption"
            v-model="searchList.provider"
            :placeholder="$t('please_select') + $t('page_material_warehousing_p_select')"
          >
            <a-select-option
              v-for="(item, index) in providers"
              :key="index"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <div style="text-align:center;padding-bottom:10px;" slot="footer">
        <a-button @click="searchOk" type="primary">{{$t('common_search')}}</a-button>
        <a-button @click="onSearchReset" style="margin-left: 10px;" type="default">{{
          $t('common_reset')
        }}</a-button>
      </div>
    </dragModal>
  </div>
</template>

<script>
import { NotifierConfigServiceProxy } from "@/service-proxies/app-v2/notify.service-proxies";
const notifierConfigServiceProxy = new NotifierConfigServiceProxy();
import Other from "./other";
export default {
  components: {
    Other,
  },
  data() {
    return {
      ConfigVisible: false,
      searchVisible: false,
      keyWords: "",
      data: [],
      selectedRowKeys: [],
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      type: "add",
      typesList: [],
      providers: [],
      modelList: [],
      properties: [],
      id: "",
      configList: {
        name: undefined,
        type: undefined,
        provider: undefined,
      },
      searchList: {
        name: undefined,
        type: undefined,
        provider: undefined,
      },
      pagination: {
        total: 0,
        pageSize: 30,
        current: 1,
      },
      rules: {
        name: [{ required: true, message: "请输入值", trigger: "blur" }],
        type: [{ required: true, message: "请选择值", trigger: "blur" }],
        provider: [{ required: true, message: "请选择值", trigger: "blur" }],
      },
    };
  },
  created() {
    this.configPageList();
  },
  watch: {
    ConfigVisible: {
      handler(val) {
        if (val) {
          this.getAllNotifyTypes();
        }
      },
    },
    "configList.type": {
      handler(val) {
        if (val) {
          this.getTypeProviders(val);
        }
      },
    },
    searchVisible: {
      handler(val) {
        if (!val) {
          // this.searchList.name = "";
          // this.searchList.type = "";
          // this.searchList.provider = "";
        }else {
          this.getAllNotifyTypes();
        }
      },
    },
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("actions"),
          dataIndex: "maintenance",
          ellipsis: true,
          width: 40,
          scopedSlots: { customRender: "maintenance" },
        },
        // {
        //   title: this.$t("配置编码"),
        //   dataIndex: "id",
        //   ellipsis: true,
        //   width: 80,
        // },
        {
          title: this.$t("page_console_configuration_name"),
          dataIndex: "name",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_notification_type"),
          dataIndex: "type",
          ellipsis: true,
          width: 80,
        },
        {
          title: this.$t("page_console_service_provider"),
          dataIndex: "provider",
          ellipsis: true,
          width: 80,
        },
      ];
    },
    modalTitle() {
      return this.type === "edit"
        ? this.$t("edit")
        : this.$t("page_workstation_maintain_config");
    },
  },
  methods: {
    getCheckboxProps(record) {
      return ({
        style: {
          display: record.id ? 'block' : 'none'
        },
        props: {
          disabled: record.id ? false: true
        }
      })
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    pageIndexchange(currentPage) {
      this.pagination.current = currentPage;
      this.configPageList();
    },
    totalFanyi(number) {
      const total = this.$t("Total…items");
      return total.replace("{0}", number);
    },
    async configPageList() {
      let res = await notifierConfigServiceProxy.configPageList(
        this.pagination.current,
        this.searchList.name,
        this.searchList.provider,
        this.pagination.pageSize,
        this.searchList.type
      );
      this.pagination.total = res.total;
      // this.data = res.records;

      let dataLength = res.records.length;
      let copy = JSON.parse(JSON.stringify(res.records));
      let needPush = 0;
      if(dataLength < 30) {
        needPush = 30 - dataLength;
        for(var k=0; k<needPush; k++) {
          let obj = {
            // id: 'none'
          }
          copy.push(obj)
        }
      }
      this.data = JSON.parse(JSON.stringify(copy));

      console.log(res, 99);
    },
    async getAllNotifyTypes() {
      let res = await notifierConfigServiceProxy.getAllNotifyTypes();
      this.typesList = res;
      console.log(res, 55);
    },
    async getTypeProviders(val) {
      let res = await notifierConfigServiceProxy.getTypeProviders(val);
      this.providers = res;
    },
    async getModel(provider, type) {
      this.modelList = [];
      let res = await notifierConfigServiceProxy.getAllTypes(type, provider);
      if (res.properties && res.properties.length > 0) {
        res.properties.map((item) => {
          this.modelList.push(
            Object.assign({}, item, {
              value: "",
            })
          );
        });
      }
      console.log(5555, this.modelList);
    },
    submit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          let obj = {};
          this.modelList.map((item) => {
            this.$set(obj, item.property, item.value);
          });
          this.$set(obj, "properties", this.properties);
          console.log(4444, obj);
          if (this.type === "add") {
            var param = {
              configuration: obj,
              description: "",
              name: this.configList.name,
              provider: this.configList.provider,
              type: this.configList.type,
            };
          } else {
            var param = {
              configuration: obj,
              description: "",
              id: this.id,
              name: this.configList.name,
              provider: this.configList.provider,
              type: this.configList.type,
            };
          }
          await notifierConfigServiceProxy.submit(param).then((res) => {
            this.configPageList();
            this.$message.success("操作成功");
            this.$refs.ruleForm.resetFields();
            this.ConfigVisible = false;
          });
        }
      });
    },
    async detail(id) {
      let res = await notifierConfigServiceProxy.detail(id);
      this.configList.name = res.name;
      this.configList.provider = res.provider;
      this.configList.type = res.type;
      console.log(999, res);
      this.modelList = [];
      let result = await notifierConfigServiceProxy.getAllTypes(
        res.provider,
        res.type
      );
      if (result.properties && result.properties.length > 0) {
        result.properties.map((item) => {
          this.modelList.push(
            Object.assign({}, item, {
              value: res.configuration[item.property],
            })
          );
        });
      }
    },
    async remove(id) {
      await notifierConfigServiceProxy.remove(id).then((res) => {
        this.$message.success("删除成功");
        this.configPageList();
      });
    },
    changeValue(val) {
      this.properties = val;
    },
    openConfig() {
      this.type = "add";
      this.modelList = [];
      this.ConfigVisible = true;
    },
    handleOk() {
      this.submit();
    },
    handleCancel() {
      this.$refs.ruleForm.resetFields();
      console.log(5555, this.configList);
      this.ConfigVisible = false;
    },
    searchForm() {
      this.searchVisible = !this.searchVisible;
    },
    openEdit(val) {
      this.detail(val.id);
      this.type = "edit";
      this.id = val.id;
      this.ConfigVisible = true;
      console.log(888, val);
    },
    delect(val) {
      this.remove(val.id);
      console.log(777);
    },
    onSelect(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
    },
    changeType(val) {
      this.modelList = [];
      this.configList.provider = undefined
      this.searchList.provider = undefined
      this.getTypeProviders(val);
      console.log(888, val);
    },
    changeProvider(val) {
      this.getModel(this.configList.type, val);
    },
    cancel(e) {
      console.log(e);
    },
    searchOk() {
      this.configPageList();
      // this.searchVisible = false;
    },
    onSearchReset(){
      this.searchList.name = undefined
      this.searchList.type = undefined
      this.searchList.provider = undefined
    },
    searchCancel() {
      this.searchVisible = false;
    },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.id);
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100%;
  width: 100%;
  background-color: #fff;
  .header {
    display: flex;
    justify-content: space-between;
    padding: 18px 0px;
  }
}
.model {
  width: 100%;
  height: 400px;
}
/deep/ .ant-row .ant-form-item {
  display: flex;
}
.ant-form-item {
  margin-bottom: 10px !important;
}
/deep/ .ant-modal-content {
  width: 1000px;
  margin-left: -100px;
}
</style>
